export type NbComponentStatus = 'primary' | 'success' | 'warning' | 'danger' | 'info';
